<template>
  <el-dialog
    :title="title"
    :visible="dialogVisible"
    width="900px"
    @close="closeModal"
    center>
    <el-form 
      class="form-box"
      label-width="140px" 
      ref="form" 
      :rules="ruleData"
      :model="formData">
      <el-form-item  label="节点名称" prop="title">
        <el-input class="expireDay-input" show-word-limit :maxlength="40" v-model.trim="formData.title" autocomplete="off"></el-input>
        <p class="grey" v-if="title!='添加一级节点'&& type!='edit'">上级节点：{{pidTitle}}</p>
        <p class="grey">新添加的节点默认未发布状态；只有该节点或子节点下有文档发布时，节点才会发布。</p>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
				<el-input
					placeholder="数字越大越靠前"
					v-model.number.trim="formData.sort">
				 </el-input>
			</el-form-item>
      <el-form-item v-if="title!='添加一级节点'" label="上级节点" prop="docMenuPid">
        <el-select v-model="formData.pidTitle" clearable placeholder="请选择" :popper-append-to-body="false">
					<el-option :value="formData.pid" class="setstyle">
						<el-tree :data="menuData" :props="defaultProps" ref="tree" :expand-on-click-node="false" :highlight-current="true" @node-click="handleNodeClick" default-expand-all>
              <div slot-scope="{ node,data}">
                <span :class="{grey:!data.isSupportUpdate}">{{ node.label }}</span>
              </div>
            </el-tree>
					</el-option> 
				</el-select>
        <p class="grey">清空时当前节点变更为一级节点，置灰节点为不可选择项</p>
      </el-form-item>
      <el-form-item label="封面图" prop="image" :error="uploadErrorInfo">
          <wk-upload
            class="w360"
            accept=".png,.PNG,.jpg,.JPG,jpeg,JPEG,.webp,.WEBP,.gif,.GIF,.svg,.SVG"
            :showProgrees="false"
            :imgUrl="formData.image"
            @uploadChange="handleImgChange"
          ></wk-upload>
      </el-form-item>
      <el-form-item label="跳转旧文档地址" prop="redirectUrl">
        <el-input class="expireDay-input" v-model.trim="formData.redirectUrl" autocomplete="off"></el-input>
        <p class="grey">此处填写旧链接，则跳转旧文档中心的链接，不填写则仍显示新文档中心</p>
			</el-form-item>
    </el-form>
    <div class="footer">
      <wk-button type="primary" class="exportButton" @click="onSubmit('form')">提交</wk-button>
      <wk-button class="exportButton" @click="closeModal()">取消</wk-button>
    </div>
  </el-dialog>
</template>

<script>

  export default {
    data() {
      var validateSort = (rule, value, callback) => {
        if ( value < 0) {
          callback("请填写大于或等于0的正整数");
        } else if ( !(/^[0-9]+.?[0-9]*/.test(value))) {
          callback("请填写数字");
        } else {
          callback();
        }
      };
			return {
        menuData: [],//导航列表
        defaultProps: {
          children: 'children',
          label: 'title',
          disabled: function(data, node) {
            // 禁用回收站选项
            if (data.isSupportUpdate == false) {
              return true
            }
          }
        },
				dialogVisible:false,
        type:"",//判断是添加还是编辑
        upperId:"",//上级节点id
        pidTitle:"",//上级节点名字
        title:"",
        uploadErrorInfo:"",
        formData:{
          title:"",
          sort:"",
          pid:"",
          pidTitle:"",
          image:'',
          redirectUrl:'',
        },
        ruleData: {//角色表单校验
          title: [
            {required: true, message: '请填写节点名称', trigger: 'blur'},
            {min: 1, max: 40, message: '节点名字最多支持40个字', trigger: ['change', 'blur']},
          ],
          sort: [
            {required: true,validator: validateSort, trigger: ['change', 'blur']},
          ],
          image: [
            {required: true, message: '请上传图片',  trigger: ['change', 'blur']},
          ],
        },
			}
    },
    created(){
      
    },
    methods: {
      //获取文档导航列表
      queryPDFMenuTree(){
        this.$apis.documentPDFServer.queryPDFMenuTree({
          id:this.upperId ? this.upperId : 0,
        }).then(res=>{
          if (res['code'] == 0){
            this.menuData = res.data;
            // 设置节点禁用
            this.loopMuduleTreeDisabled(this.menuData);
          }
        })
      },
      loopMuduleTreeDisabled(arr) {
        for(let i=0;i<arr.length;i++) {
          if (arr[i].isSupportUpdate == false) {
            this.$set(arr[i], 'disabled', true);
            return;
          }
          this.loopMuduleTreeDisabled(arr[i].children);
        }
      },
      handleImgChange(res) {
        this.uploadErrorInfo = ''
        if (res['code'] == 0) {
          this.formData.image = res.data.link
          this.$refs['form'].validateField('image');//对图片进行移除校验
        } else {
          this.uploadErrorInfo = result.message
        }
      },
      onSubmit(formName){
        this.$refs[formName].validate((valid) => {
          if(valid){
            if(this.formData.pidTitle ==""){//如果没有上级标题就是一级节点
              this.formData.pid=0
            }
            if(this.type=="add"){
              this.$apis.documentPDFServer.addPDFMenu({
                title:this.formData.title,
                sort:this.formData.sort,
                pid:this.formData.pid ? this.formData.pid : 0,
                image:this.formData.image,
                redirectUrl:this.formData.redirectUrl,
              }).then(res=>{
                if (res.code == 0) {
                  this.$emit('search', {})
                  this.closeModal();
                  this.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
                }
              })
            }else {
               this.$apis.documentPDFServer.updatePDFMenu({
                id:this.upperId,
                title:this.formData.title,
                sort:this.formData.sort,
                pid:this.formData.pid ? this.formData.pid : 0,
                image:this.formData.image,
                redirectUrl:this.formData.redirectUrl,
              }).then(res=>{
                if (res.code == 0) {
                  this.$emit('search', {})
                  this.closeModal();
                  this.$message({
                    type: 'success',
                    message: '更新成功!'
                  });
                }
              })
            } 
          }       
        })
      },
    
      //编辑默认选中已有权限的账号
      queryPDFMenuDetail(){
        this.$apis.documentPDFServer.queryPDFMenuDetail({
          id:this.upperId 
        }).then(res=>{
          if (res['code'] == 0){
            this.formData.title=res.data.title;
            this.formData.sort=res.data.sort;
            this.formData.pid=res.data.pid;
            this.formData.pidTitle=res.data.pidTitle;
            this.formData.image=res.data.image;
            this.formData.redirectUrl=res.data.redirectUrl;
          }
        })
      },
      //树形选择文档
      handleNodeClick(data, self, child) {
        if(!data.isSupportUpdate==false){
          this.formData.pidTitle = data.title;//展示部分
          this.formData.pid = data.id;//传参---id
          // this.$message.error('当前节点不能作为此节点的子节点');
        } 
      },

      show(val,data) {
        this.type=val;
        if(val=="add"){
          console.log(data)
          if(!data){
            this.title="添加一级节点"; 
          }else{
            this.pidTitle=data.title
            this.upperId=data.id;
            this.formData.pidTitle=data.title
            this.formData.pid=data.id;
            this.title= `添加${utils.toChineseNumber(data.level+1)}级节点`;
          }
        }
        if(val=="edit"){
          this.upperId=data.id;
          this.title= `编辑${utils.toChineseNumber(data.level)}级节点`;
          this.queryPDFMenuDetail();
        }
        this.dialogVisible = true;
        this.queryPDFMenuTree();
      },
      closeModal() {
        this.dialogVisible = false;
        this.upperId="";
        this.formData.pid="";
        this.formData.pidTitle="";
        this.resetForm();
      },
      resetForm() {
        this.$refs['form'].resetFields();
      },
    }
  }
</script>

<style lang="scss" scoped>
.form-box{
  padding-left: 20px;
  padding-right: 77px;
  .setstyle {
    min-height: 200px;
    padding: 0 !important;
    margin: 0;
    overflow: auto;
    cursor: default !important;
  }
}
.footer{
  margin-top: 20px;
  text-align: center;
  .exportButton{
    width: 150px;
    margin: 0 22px;
    letter-spacing: 6px !important;
  }
}
</style>
